import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import PunchCardItem from './punch-card-item';

const base_class = 'm2g-order-loyalty-punch-card';

const Punchcard = ({
    title,
    description,
    num_punches_needed,
    punches,
}) => {

    return (
        <div className={`${base_class} m2g-customer-loyalty-program-punchcard` } >
            <div className={`${base_class}-program-container`}>
                <div
                    className={clsx(
                        `${base_class}-icon`,
                        'm2g-icon',
                        'm2g-icon--award',
                        'm2g-icon--medium'
                    )}
                    data-image={title}
                />
                <div className={`${base_class}-title`}>{title}</div>
                {description && (
                    <div
                        className={clsx(
                            `${base_class}-description`,
                            'm2g-text--offset',
                            'm2g-text--small'
                        )}
                    >
                        {description}
                    </div>
                )}
            </div>

            <div className={`${base_class}-punches-container`}>
                <div className={`${base_class}-punches`}>
                    {[...Array(num_punches_needed).keys()].map(index => (
                        <PunchCardItem
                            key={index}
                            num={index + 1}
                            isPunched={index < punches}
                            baseClass={base_class}
                        />
                    ))}
                    <div
                        className={`${base_class}-punch`}
                        data-is-reward
                    >
                        <div
                            className={`${base_class}-punch-content`}
                        >
                            <span
                                className={`${base_class}-punch-content ${base_class}-punch-content--reward m2g-icon m2g-icon--gift`}
                            />
                        </div>
                    </div>
                </div>

                <div className={`${base_class}-punch-count-progress`}>
                    <div
                        className={`${base_class}-punch-count-progress-number-container`}
                    >
                        <span
                            className={`${base_class}-punch-count-progress-number`}
                        >
                            {punches}
                        </span>
                    </div>

                    <div className={`${base_class}-punch-count-progress-bar`}>
                        <div
                            className={`${base_class}-punch-count-progress-bar-label`}
                        >
                            {title}
                        </div>
                        <div
                            className={`${base_class}-punch-count-progress-bar-container`}
                        >
                            <div
                                className={clsx(
                                    `${base_class}-punch-count-progress-bar-content`,
                                    `${base_class}-punch-count-progress-bar-content--earned`
                                )}
                                style={{
                                    width: `${(punches / num_punches_needed) *
                                        100}%`,
                                }}
                            />
                            <div
                                className={`${base_class}-punch-count-progress-bar-content ${base_class}-punch-count-progress-bar-content--earned-with-this-order`}
                                style={{
                                    width: `${(punches / num_punches_needed) *
                                        100}%`,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Punchcard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    num_punches_needed: PropTypes.number.isRequired,
    punches: PropTypes.number.isRequired,
};

export default Punchcard;
